module.exports = __webpack_public_path__ + "static/media/add cyclic cleanliness.5504f214.svg";